import React from "react";
import { connect } from "react-redux";
import { actions as routerActions } from "redux-router5";

import * as Routes from "../routing/routes";
import AppSecondaryBackground from "../root/app-secondary-background";
import { getBrand } from "../brand/brand-selectors";
import Guidance from "../general-info/guidance";
import { ModalType } from "../modal/modal-constants";

function GuidanceHumanBodyPage({ goTo }) {
  return (
    <AppSecondaryBackground>
      <div className="GuidanceHumanBodyPage l-container">
        <Guidance
          type={ModalType.PAIN_PROFILE_SCREEN}
          onNext={() => goTo(Routes.SELF_DIAGNOSIS_GENERAL_INFO)}
        />
      </div>
    </AppSecondaryBackground>
  );
}

const mapState = state => ({
  brand: getBrand(state)
});
const mapDispatch = {
  goTo: routerActions.navigateTo
};

GuidanceHumanBodyPage = connect(
  mapState,
  mapDispatch
)(GuidanceHumanBodyPage);

export default GuidanceHumanBodyPage;



// WEBPACK FOOTER //
// ./src/modules/pages/GuidanceHumanBodyPage.js